export const ru = {
    add: 'Добавить к группе объявлений'
};
